import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IAuraSoftwareSuiteLicensesInfo, IUserLicencesInfo } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import { formatDateString } from "src/Utils/DateFormatting/DateFormattter";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import UnassignLicenseFromClinic from "../../UnassignLicenseFromClinic/UnassignLicenseFromClinic";
import Button from "src/SharedComponents/Button/Button";
import { isDateExpired } from "src/Utils/DateExpiry/DateExpiryChecker";

export interface IAuraAppLicensesAssigned{
    auraAppLicensesAssigned: IUserLicencesInfo[];
    distributorId: string;
    otherLicenses: IAuraSoftwareSuiteLicensesInfo[];
}

const AuraAppLicensesAssigned: React.FC<IAuraAppLicensesAssigned> = ({auraAppLicensesAssigned, distributorId, otherLicenses}) => {
    const [showUnassignLicenseConfirmDialog, setshowUnassignLicenseConfirmDialog] = useState<boolean>(false);
    const [clinicId, setClinicId] = useState<string>('');
    const [clinicName, setClinicName] = useState<string>('');
    const [entitlementId, setEntitlementId] = useState<string>('');
    const {t} = useTranslation();

    const isEntitlementIdInOtherLicenses = (id: string): boolean => {
        return otherLicenses.some((license) => license.entitlementId === id);
    };

    return(
        <>
            {showUnassignLicenseConfirmDialog &&
                <UnassignLicenseFromClinic
                    entitlementId={entitlementId}
                    clinicId={clinicId}
                    clinicName={clinicName}
                    closeDialog={() => setshowUnassignLicenseConfirmDialog(false)}
                    distributorId={distributorId}
                />
            }
            <GridViewCollapase title={t('Assigned')} id="aura-app-licenses-assigned">
                <div>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <th className={tableStyles.heading} style={{width: '30%', paddingTop: '0px'}}>{t('EntitlementId')}</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>{t('LicenseType')}</th>
                                <th className={tableStyles.heading} style={{width: '15%', paddingTop: '0px'}}>{t('ExpirationDate')}</th>
                                <th className={tableStyles.heading} style={{width: '15%', paddingTop: '0px'}}>{t('Seats')}</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>{t('AssignedTo')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                auraAppLicensesAssigned && auraAppLicensesAssigned.map((license: IUserLicencesInfo, index: number) => (
                                    <tr key={index}>
                                        <td className={tableStyles.data} style={{ fontWeight: '600' }}>{license?.entitlementId}</td>
                                        <td className={tableStyles.data}>{license?.licenseType}</td>
                                        <td className={tableStyles.data} style={isDateExpired(license?.licenseEndDate) ? {color: 'red'} : {}}>{license?.licenseType.toLowerCase().includes("permanent") ? '-' : (license?.licenseEndDate ? formatDateString(license?.licenseEndDate) : '-')}</td>
                                        <td className={tableStyles.data}>{license?.maximumSeats}</td>
                                        <td className={tableStyles.data}>{license?.clinicName}</td>
                                        <td className={tableStyles.data} style={{textAlign: 'end'}}>
                                            <Button
                                                    backgroundColor="#fff"
                                                    color="#A8927D"
                                                    text={t('Unassign')}
                                                    borderColor="#A8927D29"
                                                    fontSize="12px"
                                                    width='172px'
                                                    borderStyle='solid'
                                                    borderWidth='2px'
                                                    fontWeight='600'
                                                    disable={isEntitlementIdInOtherLicenses(license?.entitlementId)}
                                                    onClick={() => {
                                                        setshowUnassignLicenseConfirmDialog(true);
                                                        setClinicId(license?.clinicId);
                                                        setClinicName(license?.clinicName);
                                                        setEntitlementId(license?.entitlementId);
                                                    }}
                                                />
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </GridViewCollapase>
        </>
    );
}

export default AuraAppLicensesAssigned;